import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { brandService } from '../../services/api/brand.service';

interface BrandManagementData {
  brand_id: string;
  brand_name: string;
  manager_name: string;
  position_type: string;
}

interface BrandState {
  brandInfo: BrandManagementData[] | null;
  isLoading: boolean;
  error: string | null;
}

const initialState: BrandState = {
  brandInfo: null,
  isLoading: false,
  error: null,
};

export const fetchBrandInfo = createAsyncThunk(
  'brand/fetchBrandInfo',
  async () => {
    const response = await brandService.getUserBrandInfo();
    return response;
  }
);

const brandSlice = createSlice({
  name: 'brand',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBrandInfo.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchBrandInfo.fulfilled, (state, action) => {
        state.isLoading = false;
        state.brandInfo = action.payload;
      })
      .addCase(fetchBrandInfo.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message || 'Failed to fetch brand information';
      });
  },
});

export default brandSlice.reducer; 